import { useTranslation } from "react-i18next";
import { Outlet } from "@tanstack/react-router";

import { BrandLogo } from "../../components/brand-logo";

/**
 * The frame of the pages without a session - login, first login, password
 * reset ([F-029]): the wordmark, one card, the help line. No navigation: there
 * is nothing to navigate to before the login.
 */
export function PublicLayout(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-screen items-center justify-center bg-secondary p-6">
      <div className="w-full max-w-[420px]">
        <BrandLogo className="mx-auto mb-8 w-full max-w-[320px]" />
        <div className="rounded-xl border bg-card p-8 shadow-sm">
          <Outlet />
        </div>
        <p data-testid="public_help" className="mt-4 text-center text-xs text-muted-foreground">
          {t("auth.helpLine")}
        </p>
      </div>
    </main>
  );
}

/** The heading block every public card opens with. */
export function PublicHeading({ testid, title, lead }: { testid: string; title: string; lead?: string }): JSX.Element {
  return (
    <header className="mb-6 space-y-1.5">
      <h1 data-testid={testid} className="text-[22px] font-semibold">
        {title}
      </h1>
      {lead ? <p className="text-sm text-muted-foreground">{lead}</p> : null}
    </header>
  );
}
